import { DimensionContext } from "@/contexts/Dimension"
import { DotLottiePlayer } from "@dotlottie/react-player"
import { useContext } from "react"

interface LoadingProps {
  state?: string
}

export default function Loading({ state }: LoadingProps) {
  const { isDark } = useContext(DimensionContext)
  return (
    <>
      <div className="flex h-screen flex-col items-center justify-center">
        <DotLottiePlayer
          style={{ height: 145, width: 200 }}
          src={`/assets/animations/loader-${isDark ? "dark" : "light"}.json`}
          renderer="svg"
          autoplay
          loop
          className=""
        />
        {state && (
          <div className="text-button dark:text-dark-button mb-20 flex items-center justify-center font-medium">
            <p>
              {state}
              <span className="ml-[3px] inline-flex gap-[2px]">
                <span className="dot">.</span>
                <span className="dot">.</span>
                <span className="dot">.</span>
              </span>
            </p>
          </div>
        )}
      </div>
    </>
  )
}
